export const ANDROID_APP_LINK = 'https://vk.cc/mobileandroid';
export const RUSTORE_APP_LINK = 'https://trk.mail.ru/c/dq91v7';
export const APPGALLERY_APP_LINK = 'https://appgallery.huawei.com/#/app/C101104117';
export const IOS_APP_LINK = 'https://vk.cc/mobileios';
export const ANDROID_DIRECT_LINK = 'https://android-ac.vk-apps.ru/latest/release.apk';
export const PWA_LINK = 'https://trk.mail.ru/c/gpnli5';
export const IOS_INSTRUCTIONS_LINK = 'https://vk.ru/wall-22822305_1702372';

export const PLATFORM_IOS = 'iOS';
export const PLATFORM_ANDROID = 'Android';

export const PLATFORM_VENDOR_HUAWEI = 'Huawei';
export const PLATFORM_VENDOR_HONOR  = 'Honor;'
